import AdyenBtn from '../../adyen-button';
import { AdyeConfig } from '../../../../../payment.helpers';
import { useAppSelector } from '../../../../../../../store';

const BancontactMobileButton = () => {
    const { paymentOptionsData } = useAppSelector((state: RootState) => state.payment);
    const merchantData = paymentOptionsData?.adyen.find((adyenData: AdyeConfig) => adyenData.type === 'bcmc_mobile');

    return <AdyenBtn
        paymentType='bcmc_mobile'
        paymentMethodConfiguration={{
            name: merchantData?.name,
            type: merchantData?.type
        }}
    />;
};

export default BancontactMobileButton;
